<template lang="pug">
div
  el-card(shadow="hover")
    app-divider(label="Observações: ", :addMarginTop="false").margin-bottom
    el-row.margin-left
      el-row.margin-bottom15
        span - Cálculos efetuados com base no disposto na Lei N° 1.351 de 14 de Novembro de 2019
      el-row.margin-bottom15
        span - O pagamento da terra poderá ser efetuado à vista ou parcelado em prestações anuais
      el-row.margin-bottom15
        span - As parcelas serão atualizadas monetariamente pela variação do Índice de Preços ao Consumidor Amplo Especial (IPCA-E), que é reajustado no dia 01 de abril de cada ano
      el-row.margin-bottom15
        span - O valor do Índice de Preços ao Consumidor Amplo (IPCA-E) vigente na data atual, e considerado para a correção das parcelas é de 1.7
      el-row.margin-bottom15
        span - Do valor do imóvel, após as deduções previstas nos artigos seguintes, será concedido desconto de 50% (cinquenta por cento) para pagamento à vista
</template>

<script>
import AppDivider from '@/components/AppDivider.vue'
export default {
  components: {
    AppDivider
  }
}
</script>

<style lang="scss" scoped>
.margin-bottom {
  margin-bottom: 20px;
}

.margin-bottom15 {
  margin-bottom: 15px;
}

.margin-left {
  margin-left: 10px;
  margin-top: 10px;
}

.color {
  color: black;
}
</style>



// WEBPACK FOOTER //
// src/screens/analise/vtn/components/ObservacoesRR.vue